// Datum einer Fieldnote formatieren, Sprache-abhängig
export const formatNoteDate = (iso, lang) =>
  new Date(iso).toLocaleDateString(lang === "de" ? "de-DE" : "en-GB", {
    day: "numeric",
    month: "long",
    year: "numeric",
  });
